import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Stack,
  Link,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { endpoint } from "../../resource/Constant";
import { useSnackbar } from "notistack";
import { useCrawlingChatbotAuth } from "../Auth/CrawlingChatbotAuthProvider";
import Header from "./Header";

const SignIn = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { crawlingChatbotLogin } = useCrawlingChatbotAuth();
  const [loading , setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  
    const showSnackbar = (message: string, severity: "success" | "error" | "info") => {
      enqueueSnackbar(message, { variant: severity });
    };

  const handleSubmit = (e: React.FormEvent) => {
    console.log("handleSubmit triggered"); // 👈 ADD THIS
    e.preventDefault();
    // TODO: integrate real auth API
    setLoading(true)
    axios.post(`${endpoint}/api/crawling/signin` , {
      email : email,
      password : password
    })
    .then((res) => {
      setLoading(false)
      const token = res?.data?.data?.token;
      crawlingChatbotLogin(token); // Persist token + update auth state
      // showSnackbar(res?.data?.message || "Logged in Successfully" , "success");
      localStorage.setItem("is_website_setup_done" , res?.data?.data?.is_website_setup_done)
      localStorage.setItem("is_vector_database_done" , res?.data?.data?.is_vector_database_done)
      navigate('/crawling/index');
    })
    .catch((error) => {
      setLoading(false)
      showSnackbar(error?.response?.data?.message || "Internal Server Error" , "error")
    })
  };

  return (
    <>
    <Header/>
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background glows */}
      <Box
        sx={{
          position: "absolute",
          top: 80,
          left: 80,
          width: 360,
          height: 360,
          bgcolor: "primary.main",
          opacity: 0.25,
          borderRadius: "50%",
          filter: "blur(60px)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: 80,
          right: 80,
          width: 360,
          height: 360,
          bgcolor: "success.main",
          opacity: 0.25,
          borderRadius: "50%",
          filter: "blur(60px)",
        }}
      />

      <Card
        sx={{
          width: "100%",
          maxWidth: 480,
          boxShadow: 8,
          border: "2px solid",
          borderColor: "primary.main",
          background: "rgba(255,255,255,0.95)",
          backdropFilter: "blur(10px)",
          position: "relative",
          zIndex: 1,
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Stack spacing={3}>
            <Box textAlign="center">
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  background: "linear-gradient(135deg, #1976d2, #66bb6a)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Welcome Back
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Sign in to manage your chatbot and content.
              </Typography>
            </Box>

            <form onSubmit={handleSubmit}>
              <Stack spacing={2.5}>
                <TextField
                  label="Email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  fullWidth
                />
                <TextField
                  autoComplete="off"
                  label="Password"
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  fullWidth
                />
                <Button
                  disabled={loading}
                  type="submit"
                  variant="contained"
                  size="large"
                  sx={{
                    background: "linear-gradient(135deg, #1976d2, #42a5f5, #66bb6a)",
                    fontWeight: 600,
                    "&:hover": {
                      background: "linear-gradient(135deg, #1565c0, #1976d2, #42a5f5)",
                      boxShadow: 8,
                    },
                  }}
                >
                  Sign In
                </Button>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Link component="button" variant="body2" onClick={() => navigate("/crawling/signup")}>
                    Need an account? Sign Up
                  </Link>
                </Stack>
              </Stack>
            </form>
          </Stack>
        </CardContent>
      </Card>
    </Box>
    </>
  );
};

export default SignIn;

